import React from 'react';
import FormWrapper from '../../../../../../Components/Form/FormWrapper';
import InputField from '../../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../../Components/Button/SubmitButton';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { BankAccount } from './BankAccountSetup';
import InputWrapper from '../../../../../../Components/Form/components/InputWrapper/InputWrapper';

interface Props {
	defaultValues: BankAccount;
	onSuccess: (values: BankAccount) => void;
}

const BankAccountSetupLatamForm: React.FC<Props> = ({
	defaultValues,
	onSuccess,
}) => {
	const validationSchema = yup.object({
		number: yup.string().required(),
		name: yup.string(),
		type: yup.string(),
		cci: yup.string().required(),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues,
	});

	const handleOnSubmit = (values: any) => {
		onSuccess(values);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className='mb-3'>
				<InputWrapper>
					<InputField
						name='number'
						label='registration.account.number'
						isRequired
					/>
				</InputWrapper>
				<InputWrapper>
					<InputField name='name' label='registration.account.name' />
				</InputWrapper>
				<InputWrapper>
					<InputField name='type' label='registration.account.type' />
				</InputWrapper>
				<InputWrapper>
					<InputField name='cci' label='registration.account.cci' isRequired />
				</InputWrapper>
			</div>
			<SubmitButton onSubmit={handleOnSubmit} title='base.shared.save' />
		</FormWrapper>
	);
};

export default BankAccountSetupLatamForm;
